import { PredictionsMagicSquare } from '@shared/config/contracts/abi-typed/Web3Predictions';

import { PredictionRoundState } from '../../model/AdjacentRound/roundState';

export type PredictionRoundDto = PredictionsMagicSquare.RoundStruct;

export type PredictionParticipantsDto = PredictionsMagicSquare.ParticipantsStruct[];

export type PredictionWinnersDto = PredictionsMagicSquare.WinnersStruct[];

export type PredictionRoundsDto = readonly PredictionRoundDto[];

// The rounds from the smart contract always come in the following order:
export const StatesDto = [
  PredictionRoundState.ACTIVE,
  PredictionRoundState.LOCKED,
  PredictionRoundState.CLOSED,
];
